// extracted by mini-css-extract-plugin
export default {"image":"image_c34TK","secoundImage":"secoundImage_MtOXs","fade":"fade_ahkZt","fade-in-animation":"fade-in-animation_yZnXw"};